var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-color": "basic",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 3H14V5H10V3ZM17 5H15V3H17.2222C18.2041 3 19 3.79594 19 4.77778V19.2222C19 20.2041 18.2041 21 17.2222 21H6.77778C5.79594 21 5 20.2041 5 19.2222V4.77778C5 3.79594 5.79594 3 6.77778 3H9V5H7V19H17V5ZM15 7H9V8H15V7ZM9 10H15V11H9V10ZM9 16H15V17H9V16ZM9 13H14V14H9V13Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/order.dcfa8db988b5ab77f661d5822591ef44.svg";
export { ForwardRef as ReactComponent };